module.exports = __webpack_public_path__ + "static/media/Sharp-Tech-Literature-LS013B7DD02-12-2-19.56915dac.pdf";